import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TipoPagamento } from './conta-parcela.model';
import { AcaoNotaFiscalSubstituicao, ContaParcelaNotaFiscalContaPagar, NotaFiscalContaPagarParcelaRequest } from './nota-fiscal-conta-pagar.model';

@Injectable()
export class ContaParcelaService {

  headers = new HttpHeaders().set('X-Skip-Loader', 'true');

    getUltimoLogBoleto(boletoId: number): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/log/visualizaultimolog/' + boletoId + '/' + 1, { observe: 'response' })
    }


  getVisualizaNfsePorContaParcela(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualizanfseporcontaparcela/' + itemId, { observe: 'response' })
  }

  postVisualizaParcelasPorFiltro(item: any): Observable<HttpResponse<any>> {
      let headersDaRequisicao = this.headers;

      if (item.skipLoader === false) {
        headersDaRequisicao = this.headers.set('X-Skip-Loader', 'false');
      }

      return this.http.post<any>(
        environment.webApiSaguiControlUrl +
          '/api/contaparcela/visualizaparcelasporfiltro/',
        item,
        {
          headers: headersDaRequisicao,
          observe: 'response'
        }
      );
}

  getContaCorrente(contaParcelaId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualizacontacorrente/' + contaParcelaId, { observe: 'response' })
  }

  postReciboPorEmail(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/enviareciboporemail', item, { observe: 'response' })
  };

  postGeraNfse(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/geranfse', item, { observe: 'response' })
  };

  gerarDpsNfse(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + `/api/contaparcela/gerar-dps-nfse/${item.contaParcelaId}`, item, { observe: 'response' })
  };

  postCancelarContaParcelas(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/exclui', item, { observe: 'response' })
  };

  getContaParcela(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualiza/' + itemId, { observe: 'response' })
  }

  postContaParcela(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/incluir-parcela/' + item.tipoConta, item, { observe: 'response' })
  };

  postContaParcelaRecorrente(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/incluirrecorrencia', item, { observe: 'response' })
  };

  postImprimirRecibo(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/imprimirrecibo', item, { observe: 'response' })
  };

  putContaParcela(itemId: any, item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contaparcela/atualiza/' + itemId, item, { observe: 'response' })
  };

  putContaParcelaCorrigir(itemId: any, item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contaparcela/corrigir/' + itemId, item, { observe: 'response' })
  };

  // tipoConta: conta a receber (0) ou a pagar (1), usado na validação de permissão
  putContaParcelaAlterarDescricao(tipoConta: number, item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contaparcela/alterar-descricao/' + tipoConta, item, { observe: 'response' })
  };

  postContaParcelaPorPeriodo(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualizaparcelasporfiltro/', item, { observe: 'response' })
  }

  getDadosVendaCartao(itemId: any): Observable <HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/buscadadoscartao/' + itemId, {observe: 'response'}
    )
  }


  buscaDadosGerais(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contaparcela/busca-dados-gerais/', item, {
        headers: this.headers,
        observe: 'response'
        });
  }
  
  substituirPorNova(tpConta: number, contaParcelaId: number, acaoNotaFiscal: AcaoNotaFiscalSubstituicao): Observable <HttpResponse<any>> {
    const url = environment.webApiSaguiControlUrl +`/api/contaparcela/substituir-por-nova/${tpConta}/${contaParcelaId}`;

    return this.http.post(url, null, { params: { acaoNotaFiscal: acaoNotaFiscal }, observe: 'response', });

  }

  substituirPorExistentes(tpConta: number, contaParcelaId: number, parcelasSubstitutasIds: number[], acaoNotaFiscal: AcaoNotaFiscalSubstituicao): Observable <HttpResponse<any>> {
    const url = environment.webApiSaguiControlUrl +`/api/contaparcela/substituir-por-existentes/${tpConta}/${contaParcelaId}`;

    return this.http.post(url, parcelasSubstitutasIds, { params: { acaoNotaFiscal: acaoNotaFiscal }, observe: 'response', });
  }

  getNotaFiscalContaAPagar(contaParcelaId: number): Observable<HttpResponse<ContaParcelaNotaFiscalContaPagar>> {
    return this.http.get<ContaParcelaNotaFiscalContaPagar>(
      environment.webApiSaguiControlUrl + `/api/contaparcela/consultar-nota-fiscal-conta-a-pagar/${contaParcelaId}`, { observe: 'response' });
  }

  postInformarNotaFiscalContaAPagar(contaParcelaId: number, item: NotaFiscalContaPagarParcelaRequest): Observable<HttpResponse<number>> {
    return this.http.post<number>(
      environment.webApiSaguiControlUrl + `/api/contaparcela/informar-nota-fiscal-conta-a-pagar/${contaParcelaId}`, item, { observe: 'response' });
  }

  putAlterarNotaFiscalContaAPagar(contaParcelaId: number, item: NotaFiscalContaPagarParcelaRequest): Observable<HttpResponse<number>> {
    return this.http.put<number>(
      environment.webApiSaguiControlUrl + `/api/contaparcela/alterar-nota-fiscal-conta-a-pagar/${contaParcelaId}`, item, { observe: 'response' });
  }

  buscarParaSubstituicaoPorParceiro(termo: string, skip: number, tamanhoPagina: number, tpConta: number, contaParcelaId: number): Observable <HttpResponse<any>> {
    const url = environment.webApiSaguiControlUrl + `/api/contaparcela/consultar-substitutas-por-parceiro/${tpConta}/${contaParcelaId}`;
    const params = {
      termo: termo,
      skip: skip,
      take: tamanhoPagina,
    }

    return this.http.get(url, {params: params, headers: this.headers, observe: 'response'});
  }

  buscarParaSubstituicaoPorDescricao(termo: string, skip: number, tamanhoPagina: number, tpConta: number, contaParcelaId: number): Observable <HttpResponse<any>> {
    const url = environment.webApiSaguiControlUrl + `/api/contaparcela/consultar-substitutas-por-descricao/${tpConta}/${contaParcelaId}`;
    const params = {
      termo: termo,
      skip: skip,
      take: tamanhoPagina,
    }

    return this.http.get(url, {params: params, headers: this.headers, observe: 'response'});
  }

  buscarParaSubstituicaoPorId(id: number, tpConta: number, contaParcelaId: number): Observable <HttpResponse<any>> {
    const url = environment.webApiSaguiControlUrl + `/api/contaparcela/consultar-substitutas-por-id/${tpConta}/${contaParcelaId}`;
    const params = {
      id: id
    }

    return this.http.get(url, {params: params, observe: 'response'});
  }
  
  

  carregarOpcoesPagamento(): any[] {
    const chavesEnum = Object.keys(TipoPagamento).filter(key => isNaN(Number(key)));
    let opcoesTipoPagamento: { valor: number; texto: string }[] = [];

    opcoesTipoPagamento = chavesEnum.map(chave => {
      return {
        valor: TipoPagamento[chave],
        texto: chave
      };
    });

    return opcoesTipoPagamento;
  }

  fixaHoraParcela(parcela: FormGroup): void {

    const dataVencimentoValue = parcela.get('dataVencimento')?.value;
    const dataPagamentoValue = parcela.get('dataPagamento')?.value;

    if (dataVencimentoValue) {
      const vencimento = new Date(dataVencimentoValue);

      if (vencimento.getHours() !== 12) {
        vencimento.setHours(12, 0, 0, 0);
        parcela.get('dataVencimento')?.setValue(vencimento, { emitEvent: false });
      }
    }

    if (dataPagamentoValue) {
      const pagamento = new Date(dataPagamentoValue);

      if (pagamento.getHours() !== 12) {
        pagamento.setHours(12, 0, 0, 0);
        parcela.get('dataPagamento')?.setValue(pagamento, { emitEvent: false });
      }
    }
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
